// 所有弹出框的组件，弹出框具体内容通过slot插槽定义，但是样式由这里统一管理
<template>
  <div class="model">
    <el-dialog
      :append-to-body="appendToBody"
      :title="title"
      :visible.sync="dialogVisible"
      :width="width"
      :close-on-click-modal="false"
      @close="this.cancel"
    >
      <slot></slot>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <ul
          class="tips_warpper text-left"
          v-show="tips.length>0"
        >
          <li
            class="text-hidden"
            v-for="(item, index) in tips"
            :key="index"
          >
            <span>{{item.type}}</span>:
            <span>{{item.value}}</span>
          </li>
        </ul>
        <a
          class="btn btn-edit"
          @click="cancel"
        >取 消</a>
        <slot name="otherBtn"></slot>
        <a
          class="btn btn-save"
          @click="confirm"
        >确 定</a>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      default: '操作'
    },
    width: {
      default: '40%'
    },
    tips: {
      type: Array,
      default: () => {
        return []
      }
    },
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    open() {
      return new Promise((resolve, reject) => {
        this.dialogVisible = true
        this.$nextTick(() => {
          resolve()
        })
      })
    },
    close() {
      return new Promise((resolve, reject) => {
        this.dialogVisible = false
        this.$nextTick(() => {
          resolve()
        })
      })
    },
    cancel() {
      this.close()
      this.$emit('cancel')
    },
    confirm() {
      this.$emit('confirm')
    }
  }
}
</script>
<style lang="scss" >
.model {
  text-align: left;
  :global {
    .el-dialog__header {
      background-color: #b3b5b7;

      .el-dialog__title {
        color: white;
        line-height: 12px;
      }

      .el-dialog__headerbtn {
        top: 16px;
        right: 16px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: white;
      }
    }

    .el-dialog__footer {
      position: relative;
      border-top: 1px solid $border-color;
      .dialog-footer {
        line-height: 32px;
        text-align: center;
        white-space: nowrap;
      }
    }
  }
}
.tips_warpper {
  // position: absolute;
  // bottom: 10px;
  // width: 70%;
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 70%;
  text-align: left;
  & li {
    display: block;
    color: $gray-color;
  }
  & li > span:nth-child(1) {
    color: red;
  }
}

.btn {
  background: transparent;
  font-size: 14px;
  border-radius: 4px;
  padding: 2px 15px;
  margin: 0;
  display: inline-block;
  line-height: 32px;
  text-align: center;
  &:not(:first-of-type) {
    margin-left: 10px;
  }
}
.btn-save {
  background-color: #409eff;
  border-radius: 4px;
  color: white;
  &:hover {
    color: white;
  }
}

.btn-edit {
  background-color: #d9d9d9;
  border-radius: 4px;
  color: white;
  &:hover {
    color: white;
  }
}
</style>
